import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faBox, faHome } from "@fortawesome/free-solid-svg-icons";
import { resetCheckout } from "../../redux/checkout/action";
import { getOrderDetailApi } from "../../services/api.services";
import { checkoutIdParamUrl, groceryListSentFlag } from "../../helper/constant";
import { serverResponse } from "../../util/fakeServer";
import "./Checkout.page.css";

function OrderConfirmedPage(props) {
  const navigate = useNavigate();
  const { isAuthenticated } = props;
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("order_id");
  const cleared = useRef(false);
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (!cleared.current) {
      props.resetCheckout();
      localStorage.removeItem(checkoutIdParamUrl);
      // Marca la lista come "inviata": al ritorno sul volantino il
      // DashboardLayout mostra la modale "svuota o mantieni" (parità col
      // vecchio flusso GroceryList.completeOrder, che settava lo stesso flag).
      try {
        localStorage.setItem(groceryListSentFlag + serverResponse.leaflet.code, "true");
      } catch { /* ignore */ }
      cleared.current = true;
    }
  }, []);

  // Verifica lo stato REALE dell'ordine: get-order richiede login, quindi solo
  // per i loggati. Per il guest non c'è endpoint pubblico -> messaggio soft.
  useEffect(() => {
    let cancelled = false;
    if (orderId && isAuthenticated) {
      getOrderDetailApi(parseInt(orderId, 10), null)
        .then((res) => {
          if (!cancelled && res && res.status === 200 && res.data) setOrder(res.data);
        })
        .catch(() => {
          /* fallback al messaggio soft */
        });
    }
    return () => {
      cancelled = true;
    };
  }, [orderId, isAuthenticated]);

  // Se l'ordine risulta NON pagato, mostriamo "in attesa" invece di "confermato".
  const isPending = order && order.paid === false;

  return (
    <div className="co-page">
      <div className="co-layout" style={{ justifyContent: "center" }}>
        <div className="co-main" style={{ maxWidth: "500px", textAlign: "center", paddingTop: "40px" }}>
          <FontAwesomeIcon
            icon={faCheckCircle}
            style={{ fontSize: "4rem", color: isPending ? "#ffc107" : "#28a745", marginBottom: "20px" }}
          />
          <h2 style={{ fontWeight: 700, color: "#222", marginBottom: "8px" }}>
            {isPending ? "Ordine ricevuto" : "Ordine Confermato!"}
          </h2>
          {orderId && (
            <p style={{ color: "#888", fontSize: "0.95rem", marginBottom: "24px" }}>
              Numero ordine: <strong>#{orderId}</strong>
            </p>
          )}

          <div className="co-card" style={{ textAlign: "left", marginBottom: "20px" }}>
            <p style={{ color: "#555", fontSize: "0.92rem", lineHeight: 1.6 }}>
              {isPending
                ? "Il pagamento è in fase di verifica. Riceverai una conferma via email appena completato."
                : "Il tuo ordine è stato ricevuto e verrà elaborato a breve. Riceverai una conferma via email con tutti i dettagli."}
            </p>
          </div>

          <div style={{ display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap" }}>
            {isAuthenticated && (
              <button
                className="up-btn up-btn--primary"
                onClick={() => navigate("/profilo/ordini")}
              >
                <FontAwesomeIcon icon={faBox} style={{ marginRight: "6px" }} />
                Vai ai miei ordini
              </button>
            )}
            <button
              className="up-btn up-btn--outline"
              onClick={() => navigate("/leaflet")}
            >
              <FontAwesomeIcon icon={faHome} style={{ marginRight: "6px" }} />
              Torna al volantino
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.authJWT.isAuthenticated,
});

export default connect(mapStateToProps, { resetCheckout })(OrderConfirmedPage);
